import constants from "../../../constants/Preferences/rates";

const setRates = (payload) => ({
	type: constants.setRates,
	payload,
});

export default setRates;
